import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Globe } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';

export default function GoogleConnectPrompt({ height = 'h-96', reconnect = false }) {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  // 재연결 필요 시 즉시 연결 페이지로 강제 이동
  useEffect(() => {
    if (reconnect) navigate('/google/connect', { replace: true });
  }, [reconnect, navigate]);

  if (reconnect) return null;

  return (
    <div className={`flex flex-col items-center justify-center ${height} gap-3`}>
      <div className={`w-14 h-14 rounded-2xl flex items-center justify-center ${isDark ? 'bg-white/5' : 'bg-gray-100'}`}>
        <Globe size={28} className={isDark ? 'text-white/30' : 'text-gray-400'} />
      </div>
      <p className={`text-sm ${isDark ? 'text-white/40' : 'text-gray-400'}`}>
        Google 계정을 먼저 연결해주세요.
      </p>
      <button
        onClick={() => navigate('/google/connect')}
        className="flex items-center gap-2 px-5 py-2 bg-brand hover:bg-brand/90 text-white text-sm font-medium rounded-lg transition-colors"
      >
        계정 연결
      </button>
    </div>
  );
}
